import { apiCall } from "../helpers/api";

/*--------------------------------------------------------------------------------------------------- */
export const supportTickets = (params = {}) => dispatch => {
    params.path = params.path || "support-tickets";
    // params.method = params.method || "GET";

    return dispatch(apiCall(params));
}

export const getMessages = (params = {}) => dispatch => {
  params.path = params.path || "feedback-messages";
  params.method = params.method || "GET";

  return dispatch(apiCall(params));
}

export const createTicket = (params = {}) => dispatch => {
  params.path = params.path || "create-ticket";
  params.method = params.method || "POST";

  return dispatch(apiCall(params));
}

export const createMessage = (params = {}) => dispatch => {
  params.path = params.path || "feedback-messages";
  params.method = params.method || "POST";

  return dispatch(apiCall(params));
}